<template><!-- svgo-optimised -->
<svg class="icon icon__close" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.273 10.965 5.166 3.859 4.131 4.894 11.238 12 4.13 19.106l1.035 1.035 7.107-7.106 7.106 7.106 1.035-1.035L13.307 12l7.107-7.106-1.035-1.035z"/></svg>
</template>